import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./App.css";
import { AuthProvider } from "./contexts/AuthContext";
import { SalesforceProvider } from "./contexts/SalesforceContext";
import { routes } from "./routes";

const router = createBrowserRouter(routes, {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true,
  },
});

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <SalesforceProvider>
          <RouterProvider router={router} />
        </SalesforceProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
